import React, { Component } from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { withRouter } from 'react-router';
import { Scrollbars } from 'react-custom-scrollbars';
import { Button } from 'reactstrap';

import Aux from '../../../system/containers/Aux';
import Loading from '../../../system/components/Loading';
import FormWrapper from '../../../system/components/FormWrapper';
import FlexWrapper from '../../../system/components/FlexWrapper';
import { validateUser } from '../../../system/utils/UserPermissions';
import Form from '../../CruiseLines/Form';

import { actionCreators } from '../../../store/cruiseLines';
import { getCountries, getCruiseLines } from '../../../store/overview';

class DealNewCruiseLineWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      requiredPermissions: ['CREATE_CRUISE_LINE', 'ALL'],
    };
  }

  submit = (values) => {
    this.props.dispatch(actionCreators.create(values));
  };

  componentWillMount() {
    validateUser(this.props.permissions, this.state.requiredPermissions);
  }

  render() {
    const props = this.props;
    return (
      <Aux>
        <Form onSubmit={this.submit} mode='create' {...this.props} />
        <Button
          type={'button'}
          color='success'
          disabled={props.loading}
          onClick={() => {
            props.dispatch(submit('CruiseLineForm'));
            window.setTimeout(() => {
              props.dispatch(getCruiseLines());
            }, 1000);
          }}
        >
          Save Cruise Line
        </Button>
      </Aux>
    );
  }
}

function mapStateToProps(store) {
  return {
    permissions: store.auth.permissions,
    loading: store.test.loading,
    data: store.test.entry,
    regions: store.overview.regions,
  };
}

export default connect(mapStateToProps)(DealNewCruiseLineWrapper);



// WEBPACK FOOTER //
// ./src/containers/Deals/components/DealNewCruiseLineWrapper.jsx